import styled from 'styled-components';
export const TabTitle = styled.span `
	padding-right: 2rem;
`;
